export default "__VITE_ASSET__D5qCjCP6__"